import { Inject, Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { WindowToken } from "@app/util/window.token";

@Pipe({
    name: "inAppBrowserLink"
})
export class InAppBrowserLinkPipe implements PipeTransform {
    constructor(@Inject(WindowToken) public window: Window, @Inject(DomSanitizer) public sanitizer: DomSanitizer) {}

    transform(text) {
        if (text === undefined) {
            return undefined;
        } else {
            return this.sanitizer.bypassSecurityTrustHtml(text);
        }
    }
}
